var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification-card"},[_c('p',{staticClass:"notification-message-text"},[_vm._v(_vm._s(_vm.notificationDetails.notificationMessage))]),_c('p',{staticClass:"notification-time-text"},[_vm._v("Notification received on "+_vm._s(_vm.formattedNotificationTime))])])
}
var staticRenderFns = []

export { render, staticRenderFns }